import { styled } from '@grupoboticario/flora-react';

export const styles = {
  Line: styled('div', {
    background: '$backgroundSecondary',
    height: '1px',
    width: '100%',
  }),
};

export default styles;
